import { useEffect } from "react";
import { toast } from "react-toastify";

export const useAuthInterceptor = () => {
  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      if (response.status === 401) {
        toast.error("Session expired. Please log in again.", {
          theme: "colored",
        });
        localStorage.removeItem("authToken");
        window.location.href = "/login";
      }

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);
};